import { StoryData, useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'

import HelpAndSupport from './components/help-and-support/help-and-support'
import { SupportPageProps } from './get-static-props'
import { SupportPageStoryContent } from '../types/support-page'

export const SupportPage = ({
  story,
  preview,
  generatedAt,
}: SupportPageProps) => {
  const typedStory = story as StoryData<SupportPageStoryContent> & {
    rel: unknown[]
  }
  const { content } = useStoryblokState({
    story: typedStory,
    enableBridge: preview,
  })

  const SEO = Array.isArray(content?.SEO) && content.SEO[0]
  const FAQs = content.faqs

  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle="Support - cinch"
        fallbackDescription="Whether you have a specific query (or a more general one), we’re here to help. Check out the links at the bottom of the page, head to our FAQs, or get in touch with us the way that’s easiest for you."
      />

      <HelpAndSupport faqs={FAQs} />
    </>
  )
}
